import { Capacitor } from '@capacitor/core';

export const getClientPlatform = () => Capacitor.getPlatform();

export const getIsCapacitorApp = () => Capacitor.isNativePlatform();
